<div role="menuitem" class="q-action-dropdown__item">
  <button role="button" (click)="press.emit()" appClickStopPropagation>
    <span [style]="{ color: iconColor }" class="q-action-dropdown__item-icon">
      <app-icon [name]="icon"></app-icon>
    </span>
    <span class="q-action-dropdown__item-label">{{ label | translate }}</span>
  </button>
</div>
